<template>
    <div class="banner-download_wrapper">
        <div class="downlaod-title">
          <img src="../../assets/images/m_global_download_logo@3x.png" alt="果师兄">果师兄
        </div>
        <p class="slogan">{{text}}</p>
        <a class="download_btn"  :href="dl_href"  @click.prevent="sa_download_gsx_app($event,downloadinfo.download_channel,downloadinfo.download_channel_name)" >
            立即下载 (for iOS)
        </a>
    </div>
</template>

<script>
export default {
    props:{
        'downloadinfo':Object,
        'text':{
            type: String,
            default: '帮助解决苹果设备相关问题'
        },
    },
    data(){
        return{
            dl_href:window.config.gsx_dl_base+this.downloadinfo.download_channel,
         
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modules/DownloadItem.vue